import { render, staticRenderFns } from "./LineaInvestigacionPage.vue?vue&type=template&id=87f38ace"
import script from "./LineaInvestigacionPage.js?vue&type=script&lang=js&external"
export * from "./LineaInvestigacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports